import { Box, Stack, Text } from 'braid-design-system';

import * as styles from './IconContentBox.css';

interface Props {
  icon: JSX.Element;
  text: string;
}

const IconContentBox = ({ icon, text }: Props) => (
  <Box className={styles.root}>
    <Stack space="medium">
      <Box className={styles.image}>{icon}</Box>
      <Text tone="secondary">{text}</Text>
    </Stack>
  </Box>
);

export default IconContentBox;
